import _extend from 'lodash/extend';

/**
 * Customer class.
 */
export default class Customer {
    /**
     * @param {Object} data - Customer data
     * @constructor
     */
    constructor(data) {
        _extend(this, data);

        this.fullName = this.fullName || `${this.first_name} ${this.last_name}`;
    }
}



// WEBPACK FOOTER //
// ./app/services/api/customers/customer.class.js